import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  cell: {
    '&:hover': {
      backgroundColor: 'rgba(108, 89, 230, 0.05)',
    },
  },
  textCell: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 500,
    '& .edit-icon': {
      width: '24px',
      height: '24px',
    },
  },
  checkboxCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 600,
  },
}));
